import React from 'react';
import { ButtonLink } from './ButtonLink';
import { images } from '../data/site';
export function Storage() {
  return <section id="storage" aria-labelledby="storage-title" className="grid w-full scroll-mt-24 bg-sand lg:grid-cols-2" data-id="element-336" data-mp="1hdkc3c9xhbif">
      <div className="gutter order-2 flex flex-col justify-center py-14 md:py-20 lg:order-1" data-id="element-337" data-mp="1m6dfnwtnudsx">
        <h2 id="storage-title" className="display text-[clamp(2.5rem,4.5vw,5rem)] font-extrabold text-navy" data-id="element-338" data-mp="1r3wuaxu9ssle">
          Storage <span className="block text-[0.55em] font-bold text-ink-muted" data-id="element-339" data-mp="tj0r5h3xvvwz">Boats, Trailers, Campers, RVs &amp; More</span>
        </h2>
        <p className="mt-5 max-w-[48ch] text-lg leading-relaxed text-ink-muted" data-id="element-340" data-mp="13ekom7y5j2nu">
          Secure storage for a low fee, with covered and uncovered spots coming soon.
        </p>
        <div className="mt-8" data-id="element-341" data-mp="2eu9bz0fbi3p6">
          <ButtonLink href="#contact" data-id="element-342" data-mp="2ev27f58tt6s0">Ask About Storage</ButtonLink>
        </div>
      </div>
      <div className="relative order-1 min-h-[320px] lg:order-2 lg:min-h-[520px]" data-id="element-343" data-mp="2jsu9gs36q99x">
        <img src={images.storage} alt="Aerial view of boats, trailers and campers lined up in a secure storage yard" loading="lazy" className="absolute inset-0 h-full w-full object-cover" data-id="element-344" data-mp="fqenpy5aveo5" />
      </div>
    </section>;
}